import { events, emit } from 'elc-service-bus';

export class SkuAddedToCollectionUseCase {
    private skuId: string;
    private quantity: number;

    constructor(skuId: string, quantity: number = 1) {
        this.skuId = skuId;
        this.quantity = quantity;
    }

    public execute = async () => {
        const { skuId, quantity } = this;

        emit(events.ADD_SKU_TO_COLLECTION_TRIGGERED, { skuId, quantity });
    };
}
